const payeeTypeList = [
  {
    label: "Original Dealer",
    text: "Original Dealer",
    id: "1",
  },
  {
    label: "Individual Buyer",
    text: "Individual Buyer",
    id: "2",
  },
  {
    label: "Individual Seller",
    text: "Individual Seller",
    id: "3",
  },
  { label: "Third party", text: "Third party", id: "4" },
  { label: "Bank", text: "Bank", id: "6" },
  { label: "RTO Partner", text: "RTO Partner", id: "7" },
  { label: "Co-Applicant", text: "Co-Applicant", id: "8" },
  { label: "Sourcing Dealer", text: "Sourcing Dealer", id: "9" },
];

const MiscReason = [
  { text: "Select Reason", value: "Select Reason" },
  {
    text: "Interest/Foreclosure Charges for Loan cancellation",
    value: "Interest/Foreclosure Charges for Loan cancellation",
  },
  { text: "Recovery of Loan amount", value: "Recovery of Loan amount" },
  { text: "Extra amount than DA", value: "Extra amount than DA" },
  {
    text: "Extra Amount for Loan Foreclosure",
    value: "Extra Amount for Loan Foreclosure",
  },
  { text: "Others", value: "Others" },
];

const datetypesArr = [
  { text: "Date Type", value: "" },
  { text: "Payment Requested Date", value: "Payment Requested Date" },
  { text: "Payment Raised Date", value: "Payment Raised Date" },
  { text: "Payment Completed Date", value: "Payment Completed Date" },
  { text: "Payment Cancelled Date", value: "Payment Cancelled Date" },
  { text: "Payment Disbursed Date", value: "Payment Disbursed Date" },
];

const SEARCH_TYPE_ARR = [
  { text: "Loan ID", value: "Loan ID" },
  { text: "Reg No", value: "Reg No" },
  { text: "Customer Name", value: "Customer Name" },
  { text: "Dealer", value: "Dealer" },
  { text: "UTR No", value: "UTR No" },
];

const BANKBOX_SEARCH_TYPE_ARR = SEARCH_TYPE_ARR.filter(
  (val) => val.text !== "Dealer",
);

const holdStatuses = [
  { text: "Hold Status", value: "" },
  { text: "Hold Cases", value: "1" },
  { text: "Not on hold", value: "2" },
  { text: "Hold Resolved", value: "3" },
];

const txnStatusArr = [
  { label: "Open" },
  { label: "Locked" },
  { label: "Hold" },
  { label: "Cancelled" },
  { label: "In Progress" },
  { label: "Completed" },
  { label: "Failed-Retry Not Allowed" },
  { label: "Start Transaction Request" },
  { label: "Failed-Retry Allowed" },
  { label: "Resubmitted" },
];

// TXN_BANKS — dead: banks dropdown now served dynamically from backend API (getPayerAccountView)
// const TXN_BANKS = [
//   { text: "Select Bank", value: "" },
//   { text: "Razorpay-YBL(000281300003342)", value: "Razorpay-YBL(000281300003342)" },
//   { text: "Razorpay-YBL(000281300003352)", value: "Razorpay-YBL(000281300003352)" },
//   { text: "Razorpay-YBL(000281300003189)", value: "Razorpay-YBL(000281300003189)" },
// ];

const disbursementStatusColorCls = [
  "orange-status",
  "green-status",
  "red-status",
];

const disbursementSubStatusColorCls = [
  "gray-status",
  "yellow-status",
  "orange-status",
  "green-status",
  "red-status",
  "blue-status",
  "red-status",
  "blue-status",
  "gray-status",
];

const utrBankStatementArr = [
  { value: "", text: "Select Bank Name" },
  { value: 1, text: "HDFC Bank" },
];

const maxFileSize = 52428800; //50MB

const deferralListColumns = [
  "SN.",
  "Loan Id",
  "Reason",
  "Remark",
  "Due Date",
  "Deferral Status",
  "Deferral Raised Date",
];

const agingListColumns = [
  { title: "Loan ID", width: "8%" },
  { title: "RC Transfer By", width: "18%" },
  { title: "Original Docs Collected", width: "20%" },
  { title: "RC Age (Days)", width: "15%" },
  { title: "Payment Box Status", width: "20%" },
  { title: "Title Box Status", width: "18%" },
];

const dealerPendingReceiptColumns = [
  { title: "Loan ID", width: "8%" },
  { title: "RC Done By", width: "18%" },
  { title: "Original Docs Collected", width: "20%" },
  { title: "Disbursed Date", width: "20%" },
  { title: "Payment Box Status", width: "18%" },
  { title: "Title Box Status", width: "18%" },
];

const resetSortingColumns = {
  lead_id: 0,
  from_date: 0,
  cus_name: 0,
  dealer_name: 0,
  city: 0,
  stage: 0,
  assign_to: 0,
  modify_date: 0,
};

const HighlightColValMapping = {
  Maker: 2,
  MakerStep3: 2,
  Checker: 3,
  L1: 4,
  L2: 4,
};

const btnDraftType = "draft";

const ownershipOptions = [
  { text: "Select Ownership", value: "" },
  { text: "Individual", value: "Individual" },
  { text: "Company", value: "Company" },
];

const InsuranceCompanyList = [
  {
    text: "Select Insurance Company",
    value: "",
    type: "1",
  },
  {
    text: "Bharti Axa General Insurance Company Ltd. Pvt.",
    value: "1",
    type: "1",
  },
  {
    text: "Bajaj Allianz General Insurance Comp Ltd.",
    value: "2",
    type: "1",
  },
  {
    text: "Iffco Tokio General Insurance Company Ltd.",
    value: "3",
    type: "1",
  },
  {
    text: "Tata-Aig General Insurance Company Ltd.",
    value: "4",
    type: "1",
  },
  {
    text: "ICICI Lombard General Insurance Company Ltd.",
    value: "5",
    type: "1",
  },
  {
    text: "Reliance General Insurance Company Ltd.",
    value: "6",
    type: "1",
  },
  {
    text: "Royal Sundaram General Insurance Company Ltd.",
    value: "7",
    type: "1",
  },
  {
    text: "Chola Mandalam General Insurance Company Ltd.",
    value: "8",
    type: "1",
  },
  {
    text: "HDFC Ergo General Insurance Company Ltd.",
    value: "9",
    type: "1",
  },
  {
    text: "Magma HDi General Insurance Company Ltd.",
    value: "10",
    type: "1",
  },
  {
    text: "Liberty Videocon General Insurance Company Ltd.",
    value: "11",
    type: "1",
  },
  {
    text: "Universal Sompo General Insurance Company Ltd.",
    value: "12",
    type: "1",
  },
  {
    text: "Future Generali India Insurance Company Ltd.",
    value: "13",
    type: "1",
  },
  {
    text: "Shriram General Insurance Company Ltd.",
    value: "14",
    type: "1",
  },
  {
    text: "SBI  General Insurance Company Ltd.",
    value: "15",
    type: "1",
  },
  {
    text: "Raheja General Insurance Company Ltd.",
    value: "16",
    type: "1",
  },
  {
    text: "New India Assurance Company Limited.",
    value: "17",
    type: "2",
  },
  {
    text: "National Insurance Company Limited.",
    value: "18",
    type: "2",
  },
  {
    text: "The Oriental Insurance Co. Ltd.",
    value: "19",
    type: "2",
  },
  {
    text: "United India Insurance Co. Ltd",
    value: "20",
    type: "2",
  },
  {
    text: "Kotak Mahindra General Insurance Limited",
    value: "21",
    type: "1",
  },
  {
    text: "DIGIT GENERAL INSURANCE LTD",
    value: "22",
    type: "1",
  },
  {
    text: "Maruti Insurance broking Pvt. Ltd.",
    value: "23",
    type: "1",
  },
  {
    text: "Acko General Insurance Company",
    value: "24",
    type: "1",
  },
  {
    text: "DHFL General Insurance Limited",
    value: "25",
    type: "1",
  },
  {
    text: "Edelweiss General Insurance",
    value: "26",
    type: "1",
  },
  {
    text: "Navi General Insurance  Company.",
    value: "27",
    type: "1",
  },
];

const RphUserIds = ["479", "480", "481", "482"];

const ControlTypes = ["", "normal", "caution", "restricted"];

const ControlClass = ["", "green-status", "yellow-status", "red-status"];

const paymentMode = [
  { text: "Select Payment Mode", value: "" },
  { text: "Cheque", value: "CHK" },
  { text: "RTGS", value: "RTGS" },
  { text: "e-Cheque", value: "ECHK" },
  { text: "DD", value: "DD" },
  { text: "NEFT", value: "NEFT" },
  { text: "IMPS", value: "IMPS" },
];

const OfflinePaymentModes = ["DD", "ECHK", "CHK"];

const ReasonForDeviation = [
  { text: "Select Deviation Reason", value: "" },
  {
    text: "Car purchased directly from Seller (C2C transaction)",
    value: "Car purchased directly from Seller (C2C transaction)",
  },
  {
    text: "Park & Sell vehicle - payment due to another dealer",
    value: "Park & Sell vehicle - payment due to another dealer",
  },
  {
    text: "Original dealer refusing to take payment",
    value: "Original dealer refusing to take payment",
  },
  {
    text: "Exception requested by dealer",
    value: "Exception requested by dealer",
  },
  {
    text: "RC Transfer Tax and RTO Charges with held",
    value: "RC Transfer Tax and RTO Charges with held",
  },
];

const OTPPaymentMode = ["RTGS", "NEFT", "IMPS"];

const OTPPayeeType = {
  1: "Original Dealer",
  2: "Individual Buyer",
  3: "Individual Seller",
  4: "Third party",
  6: "Bank",
  7: "RTO Partner",
  8: "Co-Applicant",
  9: "Sourcing Dealer",
  10: "Delivery Dealer",
};

// OTPPayerAccount — dead: OTP requirement now read from per-account require_otp flag in API dropdown items
// const OTPPayerAccount = [
//   "YesBank(000281300003342)",
//   "YesBank(000281300003352)",
//   "Razorpay-YBL(000281300003342)",
//   "Razorpay-YBL(000281300003352)",
//   "HDFC(50200091661248)",
//   "Non 892(50200014683572)",
//   "Razorpay-YBL(000281300003189)",
// ];

const CaseType = {
  "dealer-sales": "Dealer",
  "direct-cc": "Direct",
  "direct-dealer": "Broker",
};

const ENABLELINKLOAN = true;

const RestrictAccounts = ["743001503462", "914010055023020", "913010001406298"];

const PaymentTrancheRequiredTriggers = [
  {
    errClass: "DisbursedAmount",
    name: "disbursed_amount",
    common: true,
  },
  {
    errClass: "IsPartialPayment",
    name: "is_partial_payment",
    common: true,
  },
  {
    errClass: "WithheldAmount",
    name: "with_held_amount",
    common: true,
  },
  {
    errClass: "PaymentReceivedByBank",
    name: "is_payment_received_by_bank",
  },
  { errClass: "PayeeType", name: "payee_type" },
  { errClass: "PaymentMode", name: "payment_mode" },
  { errClass: "PayableAcNumber", name: "payable_ac_number" },
  { errClass: "TrancheName", name: "tranche_name" },
  // { errClass: "PreviousFinancier", name: "previous_financier" },
  // { errClass: "PreviousLoanAccount", name: "previous_loan_account" },
  { errClass: "PayeeName", name: "payee_name" },
  { errClass: "PayeeAcNumber", name: "payee_ac_number" },
  { errClass: "PayeeIFscCode", name: "payee_ifsc_code" },
  { errClass: "PayeeBankName", name: "payee_bank_name" },
  { errClass: "PayeeBranchName", name: "payee_branch_name" },
  { errClass: "DisbursePayableAmt", name: "disburse_payable_amt" },
  {
    errClass: "RecoveredAmount",
    name: "recovered_amount",
    cancellationTrigger: true,
  },
  {
    errClass: "MoneyReturnedToBank",
    name: "money_returned_to_bank",
    cancellationTrigger: true,
  },
  {
    errClass: "ReleaseForeclosureAmount",
    name: "release_foreclosure_amount",
    foreclosureTrigger: true,
  },
  {
    errClass: "TotalForeclosureAmount",
    name: "total_foreclosure_amount",
    foreclosureTrigger: true,
  },
  {
    errClass: "DisburseBalAmt",
    name: "disburse_bal_amt",
  },
];

const TrancheNameList = {
  "RTO Charges": "rto_charges",
  "Original Documents Pending": "original_pending_charges",
  "Valuation Charges": "valuation_charges",
  "Processing Fees": "processing_charges",
  "Bank NOC Pending": "bank_noc_charges",
  "Seller Presence Required": "seller_presence_charges",
  "Dealer doing RC Transfer": "dealer_rc_charges",
  "Split Payment": "split_payment_charges",
  "Convenience Fee": "convenience_charges",
  "Foreclosure Charges": "foreclosure_charges",
  "RTO TDS & GST Charges": "gst_tds_charges",
  "PDD Pending": "pdd_pending",
  Other: "other_charges",
};

const ReasonForCancelPayment = [
  { text: "Select Reason", value: "" },
  {
    text: "Customer not interested",
    value: "1",
  },
  {
    text: "Car blacklisted RTO transfer not possible",
    value: "2",
  },
  {
    text: "NOC not available from current loan",
    value: "3",
  },
  {
    text: "Loan booked on wrong car",
    value: "4",
  },
  {
    text: "Customer returned vehicle to dealer",
    value: "5",
  },
  {
    text: "Dealer/Customer not providing docs",
    value: "6",
  },
];

const resetWithheldSortingColumns = {
  lead_id: 0,
  car_details: 0,
  cus_name: 0,
  city: 0,
  ledger_balance: 0,
  withheld_amount: 0,
  rto_agent: 0,
  pending_amount: 0,
};

const resetBulkBankPaymentSortingColumns = {
  lead_id: 0,
  bank_payment: 0,
  payment_date: 0,
  bank: 0,
  city: 0,
  cus_name: 0,
  regno: 0,
};

const resetBankBoxSortingColumns = {
  lead_id: 0,
  payment_amount: 0,
  request_date: 0,
  status: 0,
  bank_reversed_txn_date: 0,
  cancelled_time: 0,
  bank_status: 0,
};

const RESET_ENV_CONFIG_SORTING_COLUMNS = {
  id: 0,
  key: 0,
  value: 0,
  status: 0,
  added_on: 0,
  updated_on: 0,
};

const BANKBOX_WEBHOOK_CHECK_TIME = 15;

const TXN_REASON_TYPE = [
  { text: "Select Action Type", value: "" },
  { text: "Resubmit & Release Manually", value: "release_manually" },
  { text: "Transaction Resubmit", value: "txn_resubmitted" },
  { text: "Transaction Completed", value: "Transaction Completed" },
];

const CANCELLED_TXN_REASON = [
  { text: "Select Reason", value: "" },
  { text: "Incorrect amount disbursed", value: "Incorrect amount disbursed" },
  { text: "Payee details incorrect", value: "Payee details incorrect" },
  { text: "QC Mismatch", value: "QC Mismatch" },
  { text: "Net Amount Mismatch", value: "Net Amount Mismatch" },
  { text: "Others", value: "Others" },
];

const HOLD_TRANSACTION_REASON = [
  { text: "Select Reason", value: "" },
  { text: "Sales Request", value: "Sales Request" },
  { text: "Discrepancy in Payment", value: "Discrepancy in Payment" },
  { text: "Payment QC Issue", value: "Payment QC Issue" },
  { text: "Operations Request", value: "Operations Request" },
  { text: "Others", value: "Others" },
];

const OfflinePayModeValues = {
  2: "DD",
  3: "ECHK",
  4: "CHK",
};

// OfflineDefaultPayerAccount — dead: offline default now from API (result.offlineDefaultAccount)
// const OfflineDefaultPayerAccount = {
//   1: "HDFC(50200091661248)",
// };

const matchTypeOptions = [
  { value: 1, label: "Balance Matched" },
  { value: 2, label: "Balance Not Matched" },
  { value: 3, label: "Both" },
];

const PII_MASK_CHARACTER = "X";
const PII_MASK_DOT_CHARACTER = "•";

export {
  matchTypeOptions,
  payeeTypeList,
  MiscReason,
  datetypesArr,
  SEARCH_TYPE_ARR,
  BANKBOX_SEARCH_TYPE_ARR,
  holdStatuses,
  txnStatusArr,
  // TXN_BANKS, // dead: served dynamically from backend API
  disbursementStatusColorCls,
  disbursementSubStatusColorCls,
  utrBankStatementArr,
  maxFileSize,
  deferralListColumns,
  agingListColumns,
  dealerPendingReceiptColumns,
  resetSortingColumns,
  HighlightColValMapping,
  btnDraftType,
  ownershipOptions,
  InsuranceCompanyList,
  RphUserIds,
  ControlTypes,
  ControlClass,
  paymentMode,
  ReasonForDeviation,
  OTPPaymentMode,
  OTPPayeeType,
  // OTPPayerAccount, // dead: OTP now from per-account require_otp flag in API
  CaseType,
  ENABLELINKLOAN,
  OfflinePayModeValues,
  RestrictAccounts,
  PaymentTrancheRequiredTriggers,
  TrancheNameList,
  ReasonForCancelPayment,
  resetWithheldSortingColumns,
  resetBulkBankPaymentSortingColumns,
  resetBankBoxSortingColumns,
  RESET_ENV_CONFIG_SORTING_COLUMNS,
  BANKBOX_WEBHOOK_CHECK_TIME,
  TXN_REASON_TYPE,
  CANCELLED_TXN_REASON,
  HOLD_TRANSACTION_REASON,
  PII_MASK_CHARACTER,
  PII_MASK_DOT_CHARACTER,
  OfflinePaymentModes,
  // OfflineDefaultPayerAccount, // dead: offline default now from API
};
